import $ from 'jquery'

import { prevAll } from '@app/utils/jquery-alternatives'
import { isDOM } from '@app/shared/predicates'

function toggleChevron(target: EventTarget): void {
  const cardHeader = prevAll(target as HTMLElement, '.card-header')[0]

  const icon = cardHeader?.querySelector('.icon')

  if (icon) {
    icon.classList.toggle('icon-chevron-down')
    icon.classList.toggle('icon-chevron-up')
  }
}

export default (): void => {
  /*TODO: Remove Bootstrap accordion*/
  const proxyBootstrapEvents = ($dom: JQuery<Document>): void => {
    $dom.off('hidden.bs.collapse')
    $dom.off('shown.bs.collapse')

    $dom.on('hidden.bs.collapse', '.card', function (event: Event) {
      if (event.target) {
        window.eventHub.$emit('sf-accordion:closed', event.target)
      }
    })

    $dom.on('shown.bs.collapse', '.card', function (event: Event) {
      if (event.target) {
        window.eventHub.$emit('sf-accordion:opened', event.target)
      }
    })
  }

  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    if (isDOM(doc)) {
      proxyBootstrapEvents($(doc))

      window.eventHub.$off('sf-accordion:opened', toggleChevron)
      window.eventHub.$off('sf-accordion:closed', toggleChevron)
      window.eventHub.$on('sf-accordion:opened', toggleChevron)
      window.eventHub.$on('sf-accordion:closed', toggleChevron)
    }
  })
}
